import React from "react";

export default function GloveIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4198 8.32175C15.9972 8.04956 15.4288 8.1725 15.1566 8.5951L13.625 10.973L13.6209 10.9791L13.6204 10.9788C13.5359 11.1099 13.3881 11.1958 13.2206 11.1888C12.9698 11.1787 12.7749 10.9681 12.7853 10.7191L12.8457 10.0445L12.9614 8.76257L13.4642 3.19445C13.5093 2.69375 13.1367 2.24743 12.636 2.20202C12.1353 2.15689 11.689 2.52945 11.6439 3.03015L11.2083 7.85432L11.208 7.85403C11.2022 7.99027 11.0862 8.09613 10.9491 8.09064C10.8117 8.08485 10.7053 7.96973 10.7108 7.83349V2.41375C10.7108 1.91103 10.2995 1.5 9.79673 1.5C9.29429 1.5 8.88298 1.91103 8.88298 2.41375V7.92634L8.88269 7.92663C8.8769 8.06287 8.7612 8.16874 8.62381 8.16324C8.50637 8.15832 8.41612 8.07184 8.39472 7.96192L8.39009 7.96221H8.38951L7.75171 3.01395C7.68749 2.51528 7.227 2.16008 6.72862 2.22429C6.23023 2.2885 5.87474 2.749 5.93896 3.24738L6.60221 8.39262L6.60135 8.39291L6.59701 8.39378C6.60019 8.41171 6.60626 8.42906 6.60568 8.44787C6.5999 8.58439 6.48391 8.69026 6.3468 8.68448C6.23197 8.67985 6.14317 8.59741 6.11887 8.49125L6.11482 8.49212L6.11453 8.49241L5.29855 5.33174C5.17301 4.84522 4.67203 4.5496 4.18521 4.67542C3.69869 4.80096 3.40336 5.30195 3.5289 5.78847L5.60198 13.8202C5.60198 13.8202 5.70611 14.309 6.3335 15.1007L6.33755 15.0995C6.43647 15.2369 6.54494 15.3668 6.65949 15.4909V17.9047C6.65949 18.2322 6.92733 18.5 7.25477 18.5H11.6115C11.9389 18.5 12.2068 18.2322 12.2068 17.9047V15.9818C12.3968 15.838 12.5765 15.6812 12.739 15.5077L12.7431 15.5097C13.0792 15.1883 13.4772 14.578 13.4772 14.578L16.6931 9.58492C16.9653 9.16232 16.8424 8.59394 16.4198 8.32175Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const GloveWideIcon = ({ size }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8068 14.7695H22.5027C22.9882 14.7695 23.3854 14.3723 23.3854 13.8868V11.6523C23.3854 11.1668 22.9882 10.7695 22.5027 10.7695H13.8068C13.3212 10.7695 12.924 11.1668 12.924 11.6523V13.8868C12.924 14.3723 13.3212 14.7695 13.8068 14.7695ZM12.9239 22.6391C12.9239 22.2031 13.2612 21.8465 13.6732 21.8465H23.3854V26.4618C23.3854 26.5526 23.3826 26.6434 23.3771 26.7335C23.3377 27.3732 23.0645 27.9772 22.6448 28.4612C22.3177 28.8378 21.8469 29.2311 21.2316 29.2311H15.0778C14.4624 29.2311 13.9916 28.8378 13.6649 28.4612C13.2449 27.9772 12.9719 27.3732 12.9322 26.7335C12.9267 26.6434 12.9239 26.5526 12.9239 26.4618V22.6391ZM21.3854 19.3849C20.7907 19.3849 20.3085 18.9028 20.3085 18.308C20.3085 17.7132 20.7907 17.2311 21.3854 17.2311C21.9802 17.2311 22.4623 17.7132 22.4623 18.308C22.4623 18.9028 21.9802 19.3849 21.3854 19.3849ZM23.4549 16.0003H12.8544C12.5544 16.0003 12.3086 16.2461 12.3086 16.5461V20.0698C12.3086 20.3698 12.5544 20.6157 12.8544 20.6157H23.4549C23.7549 20.6157 24.0008 20.3698 24.0008 20.0698V16.5461C24.0008 16.2461 23.7549 16.0003 23.4549 16.0003ZM27.0923 23.9851L24.6166 26.4909L24.5972 21.846C24.932 21.846 25.2055 21.5725 25.2055 21.2377V19.9749C25.2055 19.2118 25.9151 18.6143 26.7101 18.8057C27.3018 18.9478 27.6932 19.5158 27.6932 20.1241V22.5349C27.6932 23.0789 27.4769 23.6005 27.0923 23.9851Z"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
